// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"103":"afe60acd","110":"65fef654","161":"b43ea7c2","235":"cf7e0854","374":"155c25ff","386":"e431372a","533":"0e5f4106","545":"2af429d9","570":"75d4cdc6","572":"3a5f592e","626":"91d0d4b6","813":"173d8cc9","925":"16403e6a","926":"05a67af6","983":"c180b84e"}[chunkId] + ".js";
};